export default {
  avbw: 'App Available Bandwidth',
  appPacketLoss: 'App Packet Loss',
  domainAvgLoss: 'Domain AvgLoss',
};
